module.exports = __webpack_public_path__ + "static/media/ciisnero.799df1c7.png";